import { useCallback, useState } from 'react';

import { localStorageService, StorageKeys } from 'shared/lib/storage/storageService';

/**
 * The user's choice about whether the step list is expanded, remembered across opens.
 *
 * `null` means they have never touched the toggle, so the caller falls back to the catalog's
 * `display_mode`. Persisted rather than held in the panel, which unmounts every time it closes.
 *
 * Only an explicit toggle belongs here. The list also closes itself to make room for an answer,
 * and writing that through would overrule a choice the user did make.
 */
export function useChecklistListOpen(): [boolean | null, (isOpen: boolean) => void] {
  const [isOpen, setIsOpen] = useState<boolean | null>(() => {
    const stored = localStorageService.get(StorageKeys.ONBOARDING_CHECKLIST_OPEN);
    return typeof stored === 'boolean' ? stored : null;
  });

  const remember = useCallback((next: boolean) => {
    setIsOpen(next);
    localStorageService.set(StorageKeys.ONBOARDING_CHECKLIST_OPEN, next);
  }, []);

  return [isOpen, remember];
}
